import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../components/inputs/input/input';
import { IValidationGroup } from '../../../../../../hooks/validation-group/validation-group-hook';
import AdyenOAuthCredentialsStore from '../../../stores/credentials/adyen-oauth-credentials-store';

interface IIntegrationProps {
    credentialsStore: AdyenOAuthCredentialsStore,
    vGroup: IValidationGroup,
}

const AdyenOAuthCredentials: React.FC<IIntegrationProps> = observer(({credentialsStore, vGroup}) => {
    return (
        <>
            <FormFieldLine 
                label='Live URL Prefix'
                note='Your Adyen live URL prefix. Required for live environment'
                key='livePrefix'
            >
                <Input
                    value={credentialsStore.livePrefix}
                    placeholder=''
                    onChange={v => credentialsStore.livePrefix = v}
                    validationGroup={vGroup}
                    required={!credentialsStore.isSandbox}
                />
            </FormFieldLine>
        </>
    )
});

export default AdyenOAuthCredentials; 